import Blockly from 'blockly/browser'
import { defineStmtBlock } from '../Util'

defineStmtBlock(
  'sirenia_api_debug_dialog',
  {
    message0: 'display %1',
    args0: [
      {
        type: 'input_value',
        name: 'MSG',
        check: 'String'
      }
    ],
    tooltip: 'Displays debug message which blocks the flow until accepted'
  },
  function(block) {
    var valueMsg = Blockly.JavaScript.valueToCode(block, 'MSG', Blockly.JavaScript.ORDER_ATOMIC)
    var code = `Debug.showDialog(${valueMsg});\n`
    return code
  }
)

defineStmtBlock(
  'sirenia_api_debugger',
  {
    message0: 'debug flow %1',
    args0: [
      {
        type: 'input_value',
        name: 'VALUE'
      }
    ],
    tooltip: 'Pauses the flow and allows inspection of runtime state'
  },
  function(block) {
    var value = Blockly.JavaScript.valueToCode(block, 'VALUE', Blockly.JavaScript.ORDER_ATOMIC)
    var code = `Debug.attach(${value});\n`
    return code
  }
)
